import styled from "styled-components";
import colors from "../utils/constants/COLORS";
export const inputWithStyle = (Component) => (props) => {
  return (
    <Container width={props.width} colors={colors}>
      <Component {...props} />
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  position: relative;
  border: 1px solid lightgray;
  padding: 5px 15px;
  border-radius: 4px;
  background-color: #fff;
  max-width: ${(props) => props.width || "220px"};
  width: 100%;
  /* height: 33.2px; */

  input,
  select {
    border: none;
    outline: none;
    width: 100%;
  }

  &:focus-within {
    border-color: #fff;
    outline: solid 2px ${(props) => props.colors.informational.color};
  }
`;
